<template>
  <div class="order-history clearfix mg_bot50" id="order-history">
    <div class="filter-container">
      <div class="filter-item date">
        <div class="text-pair">{{ $t("orders.order_history.date") }}:</div>
        <date-picker
          :disabled="disabledDatesFrom"
          v-model="startDate"
          class="date-picker-input no-right-radius"
          :format="customFormatter"
        ></date-picker>
        <date-picker
          :disabled="disabledDatesTo"
          v-model="endDate"
          class="date-picker-input no-left-radius"
          :format="customFormatter"
        ></date-picker>
      </div>
      <div class="filter-item pair">
        <div class="label-text text-pair">
          {{ $t("orders.order_history.pair") }}:
        </div>
        <div class="toolbar-element2">
          <select-box
            v-model="filters.coin"
            :placeholder="$t('order.order_history.all')"
            :options="coinMasters"
          />
        </div>
        <span class="bw-element"> / </span>
        <div class="toolbar-element2">
          <select-box
            v-model="filters.currency"
            :placeholder="$t('order.order_history.all')"
            :options="markets"
          />
        </div>
      </div>
      <div class="filter-item side">
        <div class="label-text text-pair">
          {{ $t("orders.order_history.side") }}:
        </div>
        <div class="toolbar-element2">
          <select-box
            v-model="filters.tradeType"
            :placeholder="$t('order.order_history.all')"
            :options="tradeType"
          />
        </div>
        <!--
        <select v-model="filters.tradeType" id="" class="form-control" @keyup.enter="search">
          <option value="">{{ $t('orders.order_history.all') }}</option>
          <option value="buy">{{ $t('orders.order_history.buy') }}</option>
          <option value="sell">{{ $t('orders.order_history.sell') }}</option>
        </select>
        -->
      </div>
      <div class="filter-item">
        <input
          title=""
          type="text"
          :placeholder="$t('orders.order_history.search_by_email')"
          @keyup.enter="search"
          class="form-control"
          name="searchKey"
          v-model="filters.searchKey"
        />
      </div>
      <div class="filter-item btn-action">
        <BaseButton @click="search()">
          {{ $t("orders.open_order.search") }}
        </BaseButton>
        <BaseButton @click="refresh()">
          {{ $t("orders.open_order.reset") }}
        </BaseButton>
      </div>
      <div class="filter-item">
        <div class="form-check form_check_hiden">
          <input
            type="checkbox"
            v-model="hideCanceled"
            class="form-check-input input_check_hiden"
            id="exampleCheck1"
          />
          <label class="form-check-label label_check_hiden" for="exampleCheck1">
            {{ $t("orders.order_history.hide_all_canceled") }}</label
          >
        </div>
      </div>
    </div>
    <div class="datatable" id="table_main_order_history">
      <data-table-4
        :getData="getData"
        ref="datatable"
        :column="11"
        class="scroll"
      >
        <th data-sort-field="updated_at" class="cl1 text-left">
          {{ $t("orders.order_history.time") }}
        </th>
        <th data-sort-field="email" class="cl2">
          {{ $t("orders.order_history.email") }}
        </th>
        <th data-sort-field="id" class="cl3">
          <div>{{ $t("orders.order_history.order_id") }}/</div>
          {{ $t("orders.order_history.pair") }}
        </th>
        <th data-sort-field="type" class="cl4">
          <div>{{ $t("orders.order_history.side") }}/</div>
          {{ $t("orders.order_history.type") }}
        </th>
        <th class="cl5">{{ $t("orders.order_history.average") }}</th>
        <th data-sort-field="price" class="cl6">
          {{ $t("orders.order_history.price") }}
        </th>
        <th class="cl7">
          <div>{{ $t("orders.order_history.amount") }}/</div>
          {{ $t("orders.order_history.filled") }}
        </th>
        <th data-sort-field="fee" class="cl8">
          {{ $t("orders.order_history.fee") }}
        </th>
        <th class="cl9">{{ $t("orders.order_history.total") }}</th>
        <th class="cl10">{{ $t("orders.order_history.status") }}</th>
        <th class="cl11"></th>
        <template slot="body" slot-scope="props">
          <tr
            :class="{
              'opacity-row':
                window._.get(props.item, 'status') == 'canceled' &&
                window._.get(props.item, 'executed_quantity') == 0,
            }"
          >
            <td class="cl1 text-left custom-time">
              <div>
                <template v-if="window._.get(props.item, 'updated_at')">
                  {{
                    window._.get(props.item, "updated_at")
                      | formatTimeStamp("YYYY-MM-DD")
                  }}
                </template>
                <template v-else>-</template>
              </div>
              <div>
                <template v-if="window._.get(props.item, 'updated_at')">
                  {{
                    window._.get(props.item, "updated_at")
                      | formatTimeStamp("HH:mm:ss")
                  }}
                </template>
                <template v-else>-</template>
              </div>
            </td>
            <td class="cl2">
              <div class="item_email_user">
                <span class="txt_email_user">{{
                  window._.get(props.item, "email") || "-"
                }}</span>
                <span class="tooltip_email_user">{{
                  window._.get(props.item, "email") || "-"
                }}</span>
              </div>
            </td>
            <td class="cl3">
              <div class="item_order_id">
                <span class="txt_order_id">{{
                  window._.get(props.item, "id") || "-"
                }}</span>
                <span class="tooltip_order_id">{{
                  window._.get(props.item, "id") || "-"
                }}</span>
              </div>
              <div>
                <template
                  v-if="
                    window._.get(props.item, 'coin') &&
                    window._.get(props.item, 'currency')
                  "
                >
                  {{ window._.get(props.item, "coin") | uppercase }}/{{
                    window._.get(props.item, "currency") | uppercase
                  }}
                </template>
                <template v-else>-</template>
              </div>
            </td>
            <td class="cl4">
              <div
                :class="{
                  buy: window._.get(props.item, 'trade_type') === 'BUY',
                  sell: window._.get(props.item, 'trade_type') === 'SELL',
                }"
              >
                <template v-if="window._.get(props.item, 'trade_type')">
                  {{ window._.get(props.item, "trade_type") | uppercaseFirst }}
                </template>
                <template v-else>-</template>
              </div>
              <div>
                <template v-if="window._.get(props.item, 'type')">
                  {{ window._.get(props.item, "type") | uppercaseFirst }}
                </template>
                <template v-else>-</template>
              </div>
            </td>
            <td class="cl5">
              <template
                v-if="
                  window._.get(props.item, 'executed_price') != null &&
                  window._.get(props.item, 'executed_price') !== ''
                "
              >
                {{
                  window._.get(props.item, "executed_price")
                    | formatCurrencyAmount(
                      window._.get(props.item, "currency"),
                      "auto"
                    )
                }}
              </template>
              <template v-else>-</template>
            </td>
            <td class="cl6">
              <span
                v-if="
                  window._.get(props.item, 'type') == 'MARKET' ||
                  window._.get(props.item, 'type') == 'stop_market' ||
                  window._.get(props.item, 'price') == null ||
                  window._.get(props.item, 'price') == '' ||
                  window._.get(props.item, 'status') == 'CANCELED' && window._.get(props.item, 'price') == 0
                "
                >{{ $t("orders.open_order.market") }}</span
              >
              <span
                v-else-if="
                  window._.get(props.item, 'price') != null &&
                  window._.get(props.item, 'price') !== ''
                "
                >{{
                  window._.get(props.item, "price")
                    | formatCurrencyAmount(
                      window._.get(props.item, "currency"),
                      "auto"
                    )
                }}</span
              >
              <span v-else>-</span>
            </td>
            <td class="cl7">
              <div>
                <template
                  v-if="
                    window._.get(props.item, 'quantity') != null &&
                    window._.get(props.item, 'quantity') !== ''
                  "
                >
                  {{
                    window._.get(props.item, "quantity")
                      | formatCurrencyAmount(
                        window._.get(props.item, "coin"),
                        "auto"
                      )
                  }}
                </template>
                <template v-else>-</template>
              </div>
              <div>
                <template
                  v-if="
                    window._.get(props.item, 'executed_quantity') != null &&
                    window._.get(props.item, 'executed_quantity') !== ''
                  "
                >
                  {{
                    window._.get(props.item, "executed_quantity")
                      | formatCurrencyAmount(
                        window._.get(props.item, "coin"),
                        "auto"
                      )
                  }}
                </template>
                <template v-else>-</template>
              </div>
            </td>
            <td class="cl8">
              <span v-if="window._.get(props.item, 'trade_type') === 'buy'">
                <template
                  v-if="
                    window._.get(props.item, 'fee') != null &&
                    window._.get(props.item, 'fee') !== ''
                  "
                >
                  {{
                    window._.get(props.item, "fee")
                      | formatCurrencyAmount(
                        window._.get(props.item, "coin"),
                        "auto"
                      )
                  }}
                </template>
                <template v-else>-</template>
              </span>
              <span v-else>
                <template v-if="window._.get(props.item, 'fee') === '0'">
                  0
                </template>
                <template
                  v-else-if="
                    window._.get(props.item, 'fee') != null &&
                    window._.get(props.item, 'fee') !== ''
                  "
                >
                  {{
                    window._.get(props.item, "fee")
                      | formatCurrencyAmount(
                        window._.get(props.item, "currency"),
                        "auto"
                      )
                  }}
                </template>
                <template v-else>-</template>
              </span>
            </td>
            <td class="cl9">
              <span
                v-if="
                  window._.get(props.item, 'type') == 'MARKET' ||
                  window._.get(props.item, 'type') == 'stop_market'
                "
                >0</span
              >
              <span
                v-else-if="
                  window._.get(props.item, 'total') != null &&
                  window._.get(props.item, 'total') !== ''
                "
                >{{
                  window._.get(props.item, "total")
                    | formatCurrencyAmount(
                      window._.get(props.item, "coin"),
                      "auto"
                    )
                }}</span
              >
              <span v-else>-</span>
            </td>
            <td class="cl10">
              <template v-if="props.item">{{
                props.item | order_status
              }}</template>
              <template v-else>-</template>
            </td>
            <td class="cl11">
              <BaseButton
                size="small"
                @click="viewDetail(window._.get(props.item, 'id'))"
                :disabled="
                  window._.get(props.item, 'status') == 'canceled' &&
                  window._.get(props.item, 'executed_quantity') == 0
                "
              >
                {{ $t("orders.order_history.view_detail") }}
              </BaseButton>
            </td>
          </tr>
        </template>
      </data-table-4>
    </div>
    <modal
      name="orderDetailModal"
      :title="$t('orders.order_history.trade_history')"
    >
      <div slot="body" class="body-popup" style="font-size: 10pt">
        <data-table
          :getData="getTradeHistory"
          :column="9"
          class="scroll table_popup_order_history"
        >
          <th data-sort-field="order_id" class="text-c">
            {{ $t("orders.order_history.order_id") }}
          </th>
          <th data-sort-field="created_at">
            {{ $t("orders.order_history.date") }}
          </th>
          <th data-sort-field="email">
            {{ $t("orders.order_history.email") }}
          </th>
          <th data-sort-field="coin">{{ $t("orders.order_history.pair") }}</th>
          <th data-sort-field="transaction_type">
            {{ $t("orders.order_history.side") }}
          </th>
          <th data-sort-field="price">
            {{ $t("orders.order_history.price") }}
          </th>
          <th data-sort-field="quantity">
            {{ $t("orders.order_history.filled") }}
          </th>
          <th data-sort-field="fee">{{ $t("orders.order_history.fee") }}</th>
          <th data-sort-field="amount" class="arrow-afleft">
            <span>{{ $t("orders.order_history.total") }}</span>
          </th>
          <template slot="body" slot-scope="props">
            <tr>
              <td class="f-td">
                <span>{{
                  window._.get(props.item, "transaction_type") === "SELL"
                    ? window._.get(props.item, "sell_order_id")
                    : window._.get(props.item, "buy_order_id")
                }}</span>
              </td>
              <td>
                {{ window._.get(props.item, "created_at") | timestampToDate }}
              </td>
              <td>
                <span class="text-wrap">{{
                  window._.get(props.item, "order_email")
                }}</span>
              </td>
              <td>
                {{ window._.get(props.item, "coin") | uppercase }}/{{
                  window._.get(props.item, "currency") | uppercase
                }}
              </td>
              <td
                v-if="window._.get(props.item, 'transaction_type') === 'BUY'"
                class="type-buy"
              >
                {{
                  window._.get(props.item, "transaction_type")
                    | transaction_type
                }}
              </td>
              <td v-else class="type-sell">
                {{
                  window._.get(props.item, "transaction_type")
                    | transaction_type
                }}
              </td>
              <td>
                <span
                  class="text-wrap"
                  v-if="
                    window._.get(props.item, 'price') == null ||
                    window._.get(props.item, 'price') == ''
                  "
                  >Market</span
                >
                <span class="text-wrap" v-else>{{
                  window._.get(props.item, "price")
                    | convertToBigNumber
                    | formatCurrencyAmount(
                      window._.get(props.item, "currency"),
                      "auto"
                    )
                }}</span>
              </td>
              <td>
                {{
                  window._.get(props.item, "quantity")
                    | formatCurrencyAmount(
                      window._.get(props.item, "coin"),
                      "auto"
                    )
                }}
              </td>
              <td>
                <span v-if="window._.get(props.item, 'Fee') > 0">{{
                  window._.get(
                    props.item,
                    "Fee",
                  )
                }}</span>
                <span v-else>0</span>
              </td>
              <td>
                {{
                  window._.get(props.item, "amount")
                    | formatCurrencyAmount(
                      window._.get(props.item, "coin"),
                      "auto"
                    )
                }}
              </td>
            </tr>
          </template>
        </data-table>
      </div>
      <div slot="footer"></div>
    </modal>
    <loading-modal />
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import DatePicker from "vuejs-datepicker";
import COMMON_CONST from "../../common/Const";
import DataTable4 from "../../components/DataTable4";
import Modal from "../../components/Modal";
import SelectBox from "../../components/SelectBox";
import rf from "../../lib/RequestFactory";
import BaseButton from "@/common/Button.vue";
import LoadingModal from "@/modals/common/LoadingModal.vue";
export default {
  components: {
    Modal,
    DatePicker,
    SelectBox,
    DataTable4,
    BaseButton,
    LoadingModal,
  },
  data() {
    return {
      titlePage: window.i18n.t("orders.order_history.order_history"),
      startDate: moment().subtract(6, "days").toDate(),
      endDate: new Date(),
      window: window,
      coin: "",
      filters: {
        coin: "",
        currency: "",
        tradeType: "",
        searchKey: "",
      },
      idDetail: null,
      hideCanceled: false,
      coinMasters: [],
      trades: [],
      commonConst: COMMON_CONST,
      tradeType: [
        { id: "ALL", name: window.i18n.t("orders.open_order.all") },
        { id: "BUY", name: window.i18n.t("orders.order_history.buy") },
        { id: "SELL", name: window.i18n.t("orders.order_history.sell") },
      ],
      markets: [],
    };
  },
  computed: {
    disabledDatesFrom() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      const disabled = {
        from: tomorrow, // Disable all dates in the future
      };

      if (this.endDate) {
        const endDateCopy = new Date(this.endDate);
        endDateCopy.setHours(0, 0, 0, 0);
        const dayAfterEndDate = new Date(endDateCopy);
        dayAfterEndDate.setDate(dayAfterEndDate.getDate() + 1);

        disabled.from = dayAfterEndDate < tomorrow ? dayAfterEndDate : tomorrow;
      }

      return disabled;
    },
    disabledDatesTo() {
      return {
        from: new Date(),
        to: new Date(this.startDate),
      };
    },
  },
  methods: {
    search() {
      let filterParams = {
        startDate: moment(this.startDate).startOf("day").toISOString(),
        endDate: moment(this.endDate).endOf("day").toISOString(),
      };
      if (
        this.startDate > this.endDate &&
        this.startDate.toDateString() != this.endDate.toDateString()
      ) {
        this.$toastr("error", this.$t("common.date.warning"));
        return;
      }
      if (this.filters.searchKey) {
        filterParams.searchKey = this.filters.searchKey;
      }
      if (this.hideCanceled) {
        filterParams.hideCanceled = 1;
      }
      if (this.filters.coin && this.filters.coin.id != "ALL") {
        filterParams.coin = this.filters.coin.id.toLowerCase();
      }
      if (this.filters.currency && this.filters.currency.id !== "all") {
        filterParams.currency = this.filters.currency.id;
      }
      if (this.filters.tradeType && this.filters.tradeType.id != "ALL") {
        filterParams.tradeType = this.filters.tradeType.id;
      }
      this.$refs.datatable.filter(filterParams);
    },
    refresh() {
      this.requestCoinList();
      this.resetInput();
      this.$refs.datatable.refresh();
    },
    resetInput() {
      this.filters = Object.assign(this.filters, {
        coin: "",
        currency: "",
        tradeType: "",
        searchKey: "",
      });
      this.hideCanceled = false;
      this.startDate = moment().subtract(6, "days").toDate();
      this.endDate = new Date();
    },
    getData(params) {
      this.$modal.show("modal-loading");

      let defaultParams = {
        startDate: moment(this.startDate).startOf("day").toISOString(),
        endDate: moment(this.endDate).endOf("day").toISOString(),
      };
      const finalParams = Object.entries({
        ...defaultParams,
        ...params,
      }).reduce(
        (acc, [key, value]) =>
          value != null && value !== "" ? { ...acc, [key]: value } : acc,
        {}
      );

      return rf
        .getRequest("OrderRequest")
        .getOrderHistory(finalParams)
        .finally(() => {
          this.$modal.hide("modal-loading");
        });
    },
    /*
      getMarkets() {
        return window._.map(COMMON_CONST.MARKETS, item => {
          return { id: item, name: item.toUpperCase() };
        });
      },
      */
    requestCoinList() {
      rf.getRequest("CoinSettingRequest")
        .getCoinList({ limit: 100 })
        .then((res) => {
          const resultCoins = res.data.filter((item) => item?.coin !== "usd");
          const coinList = window._.map(resultCoins, (item) => ({
            id: item.coin,
            name: item.coin.toUpperCase(),
          }));
          this.coinMasters = [
            { id: "ALL", name: window.i18n.t("orders.open_order.all") },
            ...coinList,
          ];
        });
    },
    requestCoinListByCurrency(currency) {
      const currencyParam = currency === "all" ? "" : currency;
      rf.getRequest("AdminRequest")
        .getPriceGroupCurrencyCoins(currencyParam)
        .then((res) => {
          const data = res.data || res;
          if (data && Array.isArray(data)) {
            const resultCoins = data.filter((item) => item?.coin !== "usd");
            const uniqueCoins = [
              ...new Set(resultCoins.map((item) => item.coin)),
            ];
            const coinList = uniqueCoins.map((coin) => ({
              id: coin,
              name: coin.toUpperCase(),
            }));
            this.coinMasters = [
              { id: "ALL", name: window.i18n.t("orders.open_order.all") },
              ...coinList,
            ];
          }
        })
        .catch((error) => {
          console.error("Error loading coins:", error);
          this.requestCoinList();
        });
    },
    async viewDetail(id) {
      this.orderActive = id;
      this.idDetail = id;
      CommonModal.show("orderDetailModal", {
        position: "center",
        mask: true,
        buttons: [
          {
            label: "OK",
            focused: true,
            style: {
              width: "140px",
              background: "rgb(0, 112, 192)",
            },
            callback: () => {
              CommonModal.hide("orderDetailModal");
            },
          },
        ],
      });
    },
    getTradeHistory() {
      let orderId = this.idDetail;
      return rf.getRequest("OrderRequest").getTradeByOrder(orderId);
    },
    customFormatter(date) {
      return moment(date).format("YYYY - MM - DD");
    },
  },
  watch: {
    hideCanceled: function () {
      this.search();
    },
    "filters.currency"(newValue) {
      if (newValue && newValue.id) {
        this.requestCoinListByCurrency(newValue.id);
        this.filters.coin = "";
      }
    },
  },
  mounted() {
    this.$emit("EVENT_PAGE_CHANGE", this);
    this.requestCoinList();
    this.$modal.show("modal-loading");
  },
  created() {
    rf.getRequest("AdminRequest")
      .getPriceGroupCurrency()
      .then((res) => {
        try {
          this.markets.push({
            id: "all",
            name: window.i18n.t("orders.open_order.all"),
          });
          window._.map(res, (item) => {
            if (
              typeof item.currency !== "undefined" &&
              item.currency !== "usd"
            ) {
              this.markets.push({
                id: item.currency,
                name: item.currency.toUpperCase(),
              });
            }
          });
        } catch (ex) {
          console.error(ex);
        }
      });
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/variables";
.date-picker-input {
  display: inline-block;
  input {
    padding: 0 5px 0px 30px;
    width: 135px !important;
    border-radius: 3px;
    -webkit-box-shadow: none;
    box-shadow: none;
    height: 30px;
    line-height: 30px;
    border: 1px solid #d2d6de;
    background-image: url("@/assets/images/icon/date-time.svg") !important;
    background-color: $color-white-smoke !important;
    background-size: 12px;
    background-position: center left 5px;
    background-repeat: no-repeat !important;
    color: $color-grey-dusty;
    &:hover,
    &:active,
    &:focus {
      border-color: $color-jungle-green;
      z-index: 9;
    }
  }
}
.no-left-radius {
  input {
    border-radius: 0px 3px 3px 0px;
    margin-left: -1px;
  }
}
.no-right-radius {
  input {
    border-radius: 3px 0px 0px 3px;
  }
}
#order-history {
  .sc_search_select {
    .group_search_select {
      .button_drop_search {
        height: 30px !important;
        padding: 5px 10px 5px 10px !important;
        border-radius: 3px;
        font-size: $font-small;
        font-family: $mulish-regular;
        span {
          font-size: $font-small;
        }
        i.icon-arrow1 {
          margin-left: 5px;
          color: $color_dove_gray;
        }
        &:hover,
        &:active,
        &:focus {
          border-color: $color-jungle-green;
          i.icon-arrow1 {
            color: $color-jungle-green;
          }
        }
      }
      .box_list_search_select {
        .list_search_select {
          li {
            font-family: $mulish-regular;
            &:hover,
            &:active,
            &:focus {
              color: $color-jungle-green;
            }
          }
        }
      }
    }
  }

  .modal-dialog {
    min-width: 80%;
    min-height: 400px;
    position: relative;
    top: -10%;
  }
  .modal-content {
    min-height: 400px;
    .modal-footer {
      text-align: center;
      margin-top: 30px;
    }
    .modal-header {
      padding: 30px 16px 16px 20px;
      .modal-title {
        font-family: "Mulish-Medium", sans-serif;
        font-size: 18px;
        font-weight: 500;
        color: $color-grey-dark;
        text-transform: none;
      }
    }
    .modal-body {
      padding: 0;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "@/assets/sass/variables";

.min_85 {
  min-width: 85px;
}
.min_110 {
  min-width: 110px;
}
.w_125 {
  width: 125px;
}
.item_email_user {
  display: inline-block;
  float: left;
  position: relative;
  .txt_email_user {
    display: block;
    max-width: 65px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .tooltip_email_user {
    position: absolute;
    top: 0px;
    left: 0px;
    line-height: 20px;
    padding: 5px 20px;
    left: 100%;
    background-color: $color_white;
    white-space: nowrap;
    width: auto;
    z-index: 10;
    font-size: $font_root;
    font-weight: 500;
    color: $color_mine_shaft;
    transition: 0.5s;
    display: none;
    box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.4);
    &:after {
      right: 100%;
      top: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-right-color: $color_white;
      border-width: 5px;
      margin-top: -5px;
    }
  }
  &:hover {
    .tooltip_email_user {
      display: block;
      transition: 0.5s;
    }
  }
}
.text-left {
  text-align: left;
}
.order-history {
  .filter-container {
    .form_check_hiden {
      float: left;
      margin-top: 25px;
      margin-right: 5px;
      margin-left: 5px;
      .input_check_hiden {
        float: left;
        width: 15px;
        height: 15px;
        margin: 8px 10px 5px 0px;
        cursor: pointer;
      }
      .label_check_hiden {
        float: left;
        height: 30px;
        line-height: 20px;
        padding: 5px 0px;
        margin: 0px;
        cursor: pointer;
        color: $color-grey-dusty;
        font-size: $font_smaller;
        font-weight: normal;
        font-family: $mulish-regular;
      }
    }
  }
}
.table_popup_order_history {
  min-width: 1100px;
  min-height: 315px;
}
.body-popup {
  max-height: 400px;
  overflow-y: auto;
  table {
    thead {
      border-bottom: 1pt solid $color-alto;
      th:last-child {
        text-align: right;
      }
      th {
        padding: 5px 0px 0px 15px !important;
        text-align: left;
        color: $color_grey;
        font-family: "Mulish-Medium", sans-serif;
        font-size: 13px;
        font-weight: 500;
        &.text-c {
          text-align: center;
        }
      }
      th:last-child {
        padding: 5px 20px 0px 15px !important;
        span {
          float: right;
        }
      }
    }
    tbody {
      // overflow-y: auto;
      // height: 200px !important;
      tr {
        td:last-child {
          text-align: right;
          padding-right: 18px !important;
        }
        td:first-child {
          min-width: 82px;
        }
        td:nth-child(2) {
          min-width: 170px;
        }
        td:nth-child(3) {
          min-width: 250px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        td:nth-child(4) {
          min-width: 120px;
        }
        td:nth-child(5) {
          min-width: 70px;
        }
        td:nth-child(6) {
          min-width: 90px;
        }
        td:nth-child(7) {
          min-width: 100px;
        }
        td:nth-child(8) {
          min-width: 120px;
        }
        td:nth-child(9) {
          min-width: 100px;
        }
        td {
          text-align: left;
          padding-top: 5px;
          font-family: Roboto-Regular;
          font-size: 14px;
          color: $color-grey-dark;
          line-height: 2.86;
          &.f-td {
            text-align: center;
          }
          &.type-buy {
            color: $color-type-buy !important;
          }
          &.type-sell {
            color: $color_red_text !important;
          }
        }
      }
    }
  }
}
.empty-data {
  text-align: center;
  padding-top: 15px;
  background-color: $color_white;
}
.opacity-row {
  opacity: 0.8;
}
.text-wrap {
  word-wrap: break-word;
}
.toolbar-element2 {
  display: inline-block;
  float: left;
}
.bw-element {
  float: left;
  font-size: $font_medium;
  margin-left: 5px;
  height: 30px;
  line-height: 30px;
  margin-right: 5px;
  color: $color-grey-dusty;
}
.checkbox {
  margin-top: 0px;
  display: inline-block;
  font-size: $font_root;
  margin-bottom: 0px;
  font-weight: normal;
  height: 30px;
  line-height: 30px;
  input[type="checkbox"] {
    display: none;
  }
  span {
    position: relative;
    content: "";
    display: inline-block;
    border: 1px solid $color_alto;
    width: 16px;
    height: 16px;
    top: 3px;
    left: 8px;
    border-radius: 2px;
    margin-right: 8px;
    position: relative;
    background-color: $color_white;
  }
  input:checked {
    & + span {
      &:after {
        opacity: 0.9;
        content: "";
        position: absolute;
        width: 14px;
        height: 7px;
        background: transparent;
        top: 2px;
        left: 0px;
        border: 3px solid $color_blue_logo;
        border-top: none;
        border-right: none;
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
      }
    }
  }
}

.order-history {
  .filter-container {
    margin: 10px 0px 30px 0px;
    height: 50px;
    .filter-item {
      float: left;
      margin: 0 5px;
      input {
        margin-top: 25px;
        display: inline-block;
        width: 145px;
        font-family: $mulish-regular;
        &:hover,
        &:active,
        &:focus {
          border-color: $color-jungle-green;
        }
      }
      select {
        width: 65px;
        display: inline-block;
        font-family: $mulish-regular;
        font-size: $font_root;
        &:hover,
        &:active,
        &:focus {
          border-color: $color-jungle-green;
        }
      }
      button {
        width: auto;
        margin: 25px 2px 0px 2px;
        height: 30px;
        font-size: $font-smaller;
        font-family: $mulish-regular;
      }
      .btn-reset {
        background-color: #b7ff03;
        border: 1px solid #b7ff03;
        width: 80px;
        text-transform: uppercase;
        color: #000000;
        font-weight: 500;
        &:hover {
          background-color: #c1ff28;
          border-color: #c1ff28;
        }
      }
      .btn-primary {
        padding: 0;
        min-width: 80px;
        &:hover {
          background-color: #c1ff28;
          border-color: #c1ff28;
        }
      }
      .coin-input {
        position: relative;
        display: inline-block;
        margin: 0 5px;
        margin-right: 0px;
        font-size: $font-small;
        font-family: $mulish-regular;
        .coin-option {
          background-color: $color-white;
          max-height: 210px;
          display: block;
          overflow-y: auto;
          margin-top: 5px;
          position: absolute;
          width: 79px;
          left: 5px;
          z-index: 10;
          padding: 12px 0px;
          box-shadow: 0px 3px 12px rgba(49, 49, 49, 0.51);
          &:after {
            bottom: 100%;
            left: 50%;
            border: solid transparent;
            content: " ";
            display: block;
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
            border-color: rgba(136, 183, 213, 0);
            border-bottom-color: $color_white;
            border-width: 5px;
            margin-left: -5px;
          }
          .option {
            display: block;
            width: 100%;
            line-height: 20px;
            cursor: pointer;
            padding: 3px 14px;
            font-size: 14px;
            overflow: hidden;
            &:hover {
              color: $color-jungle-green;
            }
          }
          .no-data {
            display: block;
            width: 100%;
            line-height: 20px;
            padding: 3px 14px;
            text-align: center;
            color: $color-grey-dusty;
            font-size: $font-small;
          }
        }
      }
    }
    .text-pair {
      color: $color-grey-dusty;
      font-family: $mulish-regular;
      font-size: $font-small;
      margin-bottom: 5px;
    }
    .side {
      margin: 0 10px;
    }
  }
  .form-control {
    background: $color-white-smoke;
    height: 30px;
    font-size: $font_small;
    padding-left: 11px;
    padding-right: 0;
  }
  .datatable {
    button.btnForm.bt-action {
      padding-left: 5px !important;
      padding-right: 5px !important;
      font-weight: 400 !important;
    }
  }
  .buy {
    color: $text-color-jade;
  }
  .sell {
    color: $text-color-red;
  }
  .btn-detail {
    width: auto;
    height: 24px;
    background-color: $color-caribbean-green;
    padding: 2px 10px;
    font-size: $font-smaller;
    color: $color-white;
    border: 1px solid $color-caribbean-green;
    border-radius: 3px;
    text-transform: uppercase;
    font-family: $mulish-regular;
    &:hover {
      background-color: $color-aquamarine;
      border-color: $color-aquamarine;
    }
    &:disabled {
      width: auto;
      height: 24px;
    }
  }
}
#table_main_order_history {
  // .w_90 {
  //   width: 90px;
  // }
  // .min_80 {
  //   min-width: 80px;
  // }
  // .min_90 {
  //   min-width: 90px;
  // }
  // .min_100 {
  //   min-width: 100px;
  // }
  // .min_105 {
  //   min-width: 105px;
  // }
  // .min_115 {
  //   min-width: 115px;
  // }
  table {
    thead {
      th {
        padding: 5px 2px 5px 15px;
        &:last-child {
          padding-right: 15px;
          padding-left: 2px;
        }
      }
    }
    tbody {
      td {
        padding: 8px 2px 4px 15px;
        &:last-child {
          padding-right: 15px;
          padding-left: 2px;
        }
      }
    }
  }
  td.cl1 {
    min-width: 115px;
  }
  td.cl2 {
    min-width: 105px;
  }
  td.cl3 {
    min-width: 110px;
  }
  td.cl4,
  td.cl5 {
    min-width: 98px;
  }
  td.cl6,
  td.cl7,
  td.cl8,
  td.cl9 {
    min-width: 115px;
  }
  td.cl10 {
    min-width: 120px;
  }
  td.cl11 {
    min-width: 100px;
  }
  .custom-time {
    min-width: 125px;
  }
}

.item_order_id {
  display: inline-block;
  float: left;
  position: relative;
  .txt_order_id {
    display: block;
    max-width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .tooltip_order_id {
    position: absolute;
    top: 0px;
    left: 0px;
    line-height: 20px;
    padding: 5px 20px;
    left: 100%;
    background-color: $color_white;
    white-space: nowrap;
    width: auto;
    z-index: 10;
    font-size: $font_root;
    font-weight: 500;
    color: $color_mine_shaft;
    transition: 0.5s;
    display: none;
    box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.4);
    &:after {
      right: 100%;
      top: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-right-color: $color_white;
      border-width: 5px;
      margin-top: -5px;
    }
  }
  &:hover {
    .tooltip_order_id {
      display: block;
      transition: 0.5s;
    }
  }
}
</style>
